export default "__VITE_ASSET__DHnhxZfs__"